import { render, staticRenderFns } from "./haiyaTodo.vue?vue&type=template&id=5232a79a&scoped=true&"
import script from "./haiyaTodo.vue?vue&type=script&lang=js&"
export * from "./haiyaTodo.vue?vue&type=script&lang=js&"
import style0 from "./haiyaTodo.vue?vue&type=style&index=0&id=5232a79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232a79a",
  null
  
)

export default component.exports